import { css, styled } from '../../hooks/theme';

interface DropDownOptionsProps {
  show?: boolean;
}

export const Container = styled.div`
  position: relative;
`;

export const DropDownOptions = styled.div<DropDownOptionsProps>`
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  max-height: 250px;
  margin-top: 8px;
  padding: 8px 0;

  z-index: 1;
  background: ${props => props.theme.colors.neutral.grey[0]};
  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow-y: scroll;

  display: none;

  ${props =>
    props.show &&
    css`
      display: block;
      animation: fadeIn 0.5s;
    `}

  > p {
    cursor: default;
    margin: 4px 14px;
    color: ${props => props.theme.colors.neutral.grey[70]};
    font-size: 14px;
  }

  > div {
    box-sizing: border-box;
    width: 100%;
    margin: 0 !important;
    padding: 10px 14px;
  }

  > div:hover {
    background: ${props => props.theme.colors.neutral.grey[5]};
  }
`;

export const NoResultsContainer = styled.div`
  padding: 16px;

  color: ${props => props.theme.colors.neutral.grey[70]};
`;
